<app-tab [tabs]="tabs" class="tab-view"></app-tab>